// Must be the first import: when running in burrito-golf-web's dev iframe,
// this swaps window.localStorage for a per-iframe in-memory store so
// side-by-side iframes don't fight over the shared session_id/token.
import './src/utils/iframeStorageShim';

import {registerRootComponent} from 'expo';
import App from './App';
import {Platform} from 'react-native';
import AsyncStorage from "@react-native-async-storage/async-storage";

// Before anything else could redirect, get the referrer URL and store it to the session storage
if (Platform.OS === 'web') {
  const referrer = document.referrer;

  if (referrer) {
    console.log('Referrer URL:', referrer);
    let referrerUrl = new URL(referrer);

    // Allow exact 'fullswingapps.com' and any subdomain (e.g., 'sub.fullswingapps.com'), but not e.g. 'malicious-fullswingapps.com'
    const trustedDomain = 'fullswingapps.com';
    const hostname = referrerUrl.hostname;
    if (
      hostname === trustedDomain ||
      hostname.endsWith('.' + trustedDomain)
    ) {
      // sessionStorage.setItem('referrerOrigin', referrerUrl.origin);
      AsyncStorage.setItem('referrerOrigin', referrerUrl.origin).catch(err => console.log('referrer err', err));
    }

  } else {
    console.log('No referrer URL found.');
  }
}


// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately

registerRootComponent(App);
